/* バーコード区分 */
export default {
    // QR CODE
    QR_CODE: "1",
    // CODABAR
    CODABAR: "2",
    // CODE11
    CODE11: "3",
    // CODE39
    CODE39: "4",
    // CODE93
    CODE93: "5",
    // CODE128
    CODE128: "6",
    // EAN8
    EAN8: "7",
    // EAN13
    EAN13: "8",
    // STD25
    STD25: "9",
    // INT25
    INT25: "10",
    // MSI
    MSI: "11",
    // DATAMATRIX
    DATAMATRIX: "12"
}